import { Button } from 'components/v4';

function CancelButton({ onClick }) {
    return (
        <Button
            variant="outline"
            onClick={onClick}
            sx={{ w: 142, mr: 'calc(100% - 150px)' }}>
            Cancel
        </Button>
    );
}

export default CancelButton;
